import React from 'react';
import 'antd/dist/antd.min.css';
import { ResponsiveLine } from '@nivo/line'

const RealtimeDataFetching = ({data, max, min}) => {
	
	const onClickLegend = (item, event) => {
	}

	return (
		<ResponsiveLine
			curve="monotoneX"
			colors= {{scheme: 'nivo'}}
			lineWidth={3}
			data={data}
			height={200}
			margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
			xScale={{ type: 'point' }}
			yScale={{
				type: 'linear',
				max: '0',
				min: '-1',
				stacked: false,
				reverse: false
			}}
			yFormat=" >-.2f"
			axisTop={null}
			axisRight={null}
			axisBottom={{
				tickSize: 5,
				tickPadding: 5,
				tickRotation: 0,
				legend: 'health check time',
				legendOffset: 36,
				legendPosition: 'middle'
			}}
			enableLabel={false}
			tooltip={({point}) => {
				return (
				<div style={{ background: '#fff', padding: '10px', borderRadius: '4px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)' }}>
				<strong>{'['}{point.data.x}{']'} {point.serieId} {(point.data.y < 0) ? 'Failed' : 'Success'}</strong> 
				</div>
			)}}
			axisLeft={null}
			// axisLeft={{
			//   tickSize: 5,
			//   tickPadding: 5,
			//   tickRotation: 0,
			//   legend: 'status',
			//   legendOffset: -40,
			//   legendPosition: 'middle'
			// }}
			enableGridY={false}
			pointSize={10}
			pointColor={{ theme: 'background' }}
			pointBorderWidth={2}
			pointBorderColor={{ from: 'serieColor' }}
			pointLabelYOffset={0}
			useMesh={true}
			legends={[
				{
				onClick: (item, e) => onClickLegend(item, e),

				anchor: 'bottom-right',
				direction: 'column',
				justify: false,
				translateX: 100,
				translateY: 0,
				itemsSpacing: 0,
				itemDirection: 'left-to-right',
				itemWidth: 80,
				itemHeight: 20,
				itemOpacity: 0.75,
				symbolSize: 12,
				symbolShape: 'circle',
				symbolBorderColor: 'rgba(0, 0, 0, .5)',
				effects: [
					{
						on: 'hover',
						style: {
							itemBackground: 'rgba(0, 0, 0, .03)',
							itemOpacity: 1
						},
					}
				]
				}
			]}
		/>
	)

};

export default RealtimeDataFetching;